import { CustomerCellphoneEntity } from '../entities/customer-cellphone-entity';

export default class CustomerCellphoneState {
  loaded = false;

  items: Array<CustomerCellphoneEntity> = [];
}
